// extracted by mini-css-extract-plugin
export default {"employee-container":"Deduction_employee-container__j-Dtt"};